import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Tag } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function Deals() {
  const [deals, setDeals] = useState([]);
  const navigate = useNavigate();

  useEffect(() => { api.get("/deals").then((r) => setDeals(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-10 min-h-[70vh]">
      <h1 className="font-display text-4xl font-semibold tracking-tight">Today's Deals</h1>
      <p className="text-slate-500 mt-1 mb-8">Exclusive offers from local Calgary businesses.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {deals.map((d, i) => (
          <div key={d.id} data-testid={`deal-card-${d.id}`} onClick={() => d.business && navigate(`/business/${d.business.id}`)}
            className="cursor-pointer bg-white rounded-3xl border border-slate-100 shadow-sm p-6 hover:-translate-y-1 transition-all animate-fade-up" style={{ animationDelay: `${i * 50}ms`, opacity: 0 }}>
            <div className="flex items-center gap-3 mb-3">
              <img src={d.business?.logo} alt="" className="w-12 h-12 rounded-xl object-cover" />
              <div>
                <p className="font-semibold text-sm">{d.business?.name}</p>
                <p className="text-xs text-slate-400">{d.business?.city}</p>
              </div>
            </div>
            <div className="flex items-center gap-2 mb-2"><Tag className="w-5 h-5 text-orange-500" />{d.discount && <Badge className="bg-orange-500 text-white rounded-full">{d.discount}</Badge>}</div>
            <h3 className="font-display text-lg font-semibold">{d.title}</h3>
            <p className="text-sm text-slate-500 mt-1">{d.description}</p>
            {d.valid_until && <p className="text-xs text-slate-400 mt-3">Valid until {d.valid_until}</p>}
          </div>
        ))}
      </div>
      {deals.length === 0 && <p className="text-slate-400">No deals yet.</p>}
    </div>
  );
}
